import { createFileRoute } from '@tanstack/react-router';
import { PortalFundingStepForm } from './-components/portal-new-steps/funding-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/setup/funding')({
	component: PortalFundingStepForm,
});
